/**
 * This function returns the background-size CSS property for the gradient depending on the number of colors
 *
 * @param numColors - number
 * @returns string
 */
const getBackgroundGradientSize = (numColors: number) => {
  if (numColors === 1) {
    return '100%';
  }
  if (numColors === 2) {
    return '50%, 100%';
  }
  if (numColors === 3) {
    return '33.3333%, 66.6667%, 100%';
  }
  // max 4 colors
  return '25%, 50%, 75%, 100%';
};

/**
 * This function returns the a CSS linear-gradient with the given colors
 *
 * @param colors - string[]
 * @returns string
 */
const getBackgroundGradient = (colors: string[]) => {
  if (colors.length === 1) {
    return `linear-gradient(to right, ${colors[0]}, ${colors[0]})`;
  }
  if (colors.length === 2) {
    return `linear-gradient(to right, ${colors[0]}, ${colors[0]}), linear-gradient(to right, ${colors[1]}, ${colors[1]})`;
  }
  if (colors.length === 3) {
    return `linear-gradient(to right, ${colors[0]}, ${colors[0]}), linear-gradient(to right, ${colors[1]}, ${colors[1]}), linear-gradient(to right, ${colors[2]}, ${colors[2]})`;
  }
  // max 4 colors
  return `linear-gradient(to right, ${colors[0]}, ${colors[0]}), linear-gradient(to right, ${colors[1]}, ${colors[1]}), linear-gradient(to right, ${colors[2]}, ${colors[2]}), linear-gradient(to right, ${colors[3]}, ${colors[3]})`;
};

export { getBackgroundGradientSize, getBackgroundGradient };
